export enum InCall {
  IDLE,
  ONGOING,
  COMPLETED,
  REJECTED,
  MISSED,
  FAILED,
  RINGING,
}
